<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="550px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">
          <v-icon class="toolbar-icon">mdi-progress-clock</v-icon>
          {{ (id > 0 ? `${lang.financial.periodicals.new.edit} (${lang.financial[subpage].title_s}) #${id}` : `${lang.financial.periodicals.new.title}`) }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog(true)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-1 py-3">
        <v-container class="pa-0">
          <v-form
            ref="SaveForm"
            v-model="valid"
            lazy-validation
            :disabled="get_interface.loading"
          >
            <v-row v-if="subpage === 'salary'" class="pa-0 mh-70">
              <v-col cols="12" class="py-0 px-1">
                <v-select
                  v-model="selected.ref"
                  :items="employees"
                  :label="lang.financial.periodicals.datatable.headers.employee"
                  :rules="lang.financial.periodicals.new.rules.employee"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  prepend-inner-icon="mdi-account-tie"
                  item-text="title"
                  item-value="id"
                  attach
                  filled
                  dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="pa-0 mh-70">
              <v-col cols="7" class="py-0 px-1">
                <v-select
                  v-model="selected.period"
                  :items="get_global.defaults.options.financial.periodicals.periods"
                  :label="lang.financial.periodicals.datatable.headers.period"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  prepend-inner-icon="mdi-calendar-month"
                  item-text="title"
                  item-value="id"
                  attach
                  filled
                  dense
                ></v-select>
              </v-col>
              <v-col cols="5" class="py-0 px-1">
                <v-text-field
                  v-model="selected.date"
                  :label="lang.financial.periodicals.datatable.headers.date"
                  :rules="lang.financial.periodicals.new.rules.date"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  autocomplete="new-password"
                  filled
                />
              </v-col>
            </v-row>
            <v-row class="pa-0 mh-70">
              <v-col cols="7" class="py-0 px-1">
                <v-text-field
                  v-model="selected.title"
                  :label="lang.financial.periodicals.datatable.headers.title"
                  :rules="lang.financial.periodicals.new.rules.title"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  autocomplete="new-password"
                  filled
                />
              </v-col>
              <v-col cols="5" class="py-0 px-1">
                <v-currency-field
                  v-model="selected.value"
                  :label="lang.financial.periodicals.datatable.headers.value"
                  :rules="lang.financial.periodicals.new.rules.value"
                  :loading="get_interface.loading"
                  :disabled="get_interface.loading"
                  filled
                  hide-details
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog(true)">{{ lang.financial.periodicals.new.close }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="save_(selected)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
        >
          {{ lang.financial.periodicals.new.save }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import appdata from '@/mixins/appdata'
import save from '@/mixins/defaults/save'
import utils from '@/mixins/utils'
import periodicals from './mixins/index'

export default {
  mixins: [ appdata, save, utils, periodicals ],
  props: {
    subpage: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      valid: false
    }
  },
  computed: {
    getTitle_ () {
      return this.lang.financial.periodicals
    },
    employees () {
      let getter = this.get_data.employees || []
      return getter.map(emp => {
        return {
          id: emp.id,
          title: emp.name
        }
      })
    }
  }
}
</script>

<style scoped src="./styles/save.scss" lang="scss"></style>
